import type { RequirementKey, RequirementMatcher, Requirements } from "./types";

export const required = (key: RequirementKey): RequirementMatcher => ({
  mode: "required",
  key,
});

export const confirm = (key: RequirementKey): RequirementMatcher => ({
  mode: "new",
  key,
});

export const existing = (key: RequirementKey): RequirementMatcher => ({
  mode: "existing",
  key,
});

export const always = (): RequirementMatcher => ({ mode: "always" });

export const when = (
  condition: (requirements: Requirements) => boolean,
): RequirementMatcher => ({ mode: "when", condition });
